export default __webpack_public_path__ + "static/media/blueInstagram.41f9cdc1.svg";